// axios中请求配置有baseURL选项，表示请求URL公共部分。
// `baseURL` 将自动加在 `url` 前面，除非 `url` 是一个绝对 URL

// export const baseURL = 'http://192.168.0.101:8081' //本地测试--new
// export const baseURL = 'http://8.140.150.245:8081' //本地测试--new
// export const baseURL = 'http://192.168.0.199:8081' //xzh
export const baseURL = 'https://www.weiguanyaowen.com/nms' //线上
// export const baseURL = 'http://123.57.172.37:8081' //线上
// export const baseURL = 'http://localhost:8081' //线上

